import React from "react";

import ConfirmDialog from "../../../shared/confirm-dialog";
import { CompareGroupsForm } from "./compare-groups-form";
import { useTrainingMigrationContext } from "./context/training-migration-provider";
import ScriptStartSuccessDialog from "./shared/script-start-success-dialog";

export const CompareGroupsDialog: React.FC = () => {
  const {
    compareGroupsDialogOpen,
    setCompareGroupsDialogOpen,
    resetCompareGroupsFormState,
    handleStartCompareGroups,
  } = useTrainingMigrationContext();

  return (
    <ConfirmDialog
      title="Compare SC and Training Groups"
      open={compareGroupsDialogOpen}
      setOpen={setCompareGroupsDialogOpen}
      onConfirm={async () => {
        await handleStartCompareGroups();
      }}
      width="md"
      cancelBtnLabel="Cancel"
      confirmBtnLabel="Start Script"
      onCancel={() => {
        resetCompareGroupsFormState();
        setCompareGroupsDialogOpen(false);
      }}
    >
      <CompareGroupsForm />
    </ConfirmDialog>
  );
};

export const CompareGroupsDialogWrapper: React.FC = () => {
  const {
    compareGroupsSuccessDialogOpen,
    setCompareGroupsSuccessDialogOpen,
    compareGroupsBackgroundJobId,
  } = useTrainingMigrationContext();

  return (
    <>
      <CompareGroupsDialog />
      <ScriptStartSuccessDialog
        open={compareGroupsSuccessDialogOpen}
        onClose={() => setCompareGroupsSuccessDialogOpen(false)}
        backgroundJobId={compareGroupsBackgroundJobId}
        scriptName="Compare Groups Script"
      />
    </>
  );
};
